module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "widget_events_content_day-container"
  }, [_c('div', {
    staticClass: "list_day-wrapper",
    attrs: {
      "id": _vm.wrapperId
    }
  }, [_c('div', {
    staticClass: "list_day"
  }, _vm._l((_vm.listEvents), function(events, key) {
    return _c('div', {
      staticClass: "day_item",
      attrs: {
        "id": _vm.dayID(key)
      }
    }, [_c('div', {
      staticClass: "dayTitle"
    }, [(_vm.isToday(key)) ? _c('span', [_vm._v("Today")]) : _vm._e(), _vm._v(" " + _vm._s(_vm.dayTitle(key)))]), _vm._v(" "), _c('ul', {
      class: _vm.classEventList(events)
    }, _vm._l((events), function(event) {
      return _c('li', [(event.imagelisting) ? _c('div', {
        staticClass: "event_box_image",
        class: _vm.getColorClass(event.tid, event.parents_id)
      }, [_c('div', {
        staticClass: "explore_thumb_stories"
      }, [_c('div', {
        staticClass: "front"
      }, [_c('div', {
        staticClass: "top"
      }, [_c('img', {
        attrs: {
          "src": event.imagelisting
        }
      })]), _vm._v(" "), _c('div', {
        staticClass: "bottom"
      }, [(_vm.classEventList(events) == 'contain_1_items') ? _c('h3', [_vm._v(_vm._s(event.longtitle))]) : _c('h3', [_vm._v(_vm._s(_vm._f("truncate")(event.longtitle, 50)))])])]), _vm._v(" "), _c('div', {
        staticClass: "hover"
      }, [_c('div', {
        staticClass: "close"
      }), _vm._v(" "), _c('div', {
        staticClass: "top"
      }, [_c('h3', {
        staticClass: "fit-text-3"
      }, [_vm._v(_vm._s(event.longtitle))]), _vm._v(" "), _c('p', [_vm._v(" " + _vm._s(event.description) + " ")])]), _vm._v(" "), _c('a', {
        staticClass: "bottom",
        attrs: {
          "href": event.event_url
        }
      }, [_c('span', [_vm._v("Read More")])])])])]) : _c('div', {
        staticClass: "event_box"
      }, [_c('div', {
        staticClass: "inside"
      }, [_c('a', {
        staticClass: "bg",
        class: _vm.getColorClass(event.parents_id),
        attrs: {
          "href": event.event_url
        }
      }, [_c('div', {
        staticClass: "title"
      }, [_vm._v(_vm._s(event.longtitle))]), _vm._v(" "), _c('div', {
        staticClass: "time"
      }, [_vm._v(_vm._s(event.datetime))])])])])])
    }))])
  }))]), _vm._v(" "), _c('ScrollBar')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4c864898","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/calendar/CalendarDay.vue
// module id = 565
// module chunks = 1